import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  settingsUpdated: false,
  dashboardUpdated: false,
  dashboardLoading: true,
  globalSynced: true,
  leadsFields: [],
  dealsFields: [],
  sysSettings: [],
  dashboardData: [],
  globalSearchResult: [],
  systemNotification: [],
  usersSystemNotifications: [],
  systemAnnouncement: []
};

const systemSettingSlice = createSlice({
  name: "systemSettings",
  initialState,
  reducers: {
    getSystemSettings(state, action) {
      state.sysSettings = action.payload;
    },
    updateSystemSettings(state, action) {
      state.settingsUpdated = true;
    },
    getLeadFields(state, action) {
      state.leadsFields = action.payload;
    },
    updateLeadFields(state, action) {
      state.settingsUpdated = true;
    },
    getAdminDashboard(state, action) {
      state.dashboardLoading = false;
      state.dashboardData = action.payload;
      state.dashboardUpdated = true;
    },
    getDealFields(state, action) {
      state.dealsFields = action.payload;
    },
    updateDealFields(state, action) {
      state.settingsUpdated = true;
    },
    globalSynced(state, action) {
      state.globalSynced = true;
    },
    globalRecordSearch(state, action) {
      state.globalSearchResult = action.payload;
    },
    fetchSystemNotifications(state, action) {
      state.systemNotification = action.payload;
    },
    updateSystemNotifications(state, action) {
      state.systemNotification.notifications = action.payload;
    },
    setUsersSystemNotifications(state, action) {
      state.usersSystemNotifications = action.payload;
    },
    updateSystemNotificationsDetails(state, action) {
      state.systemNotification = action.payload;
    },
    fetchSystemAnnoucements(state, action) {
      state.systemAnnouncement = action.payload;
    },
    reset: (state) => initialState,
    logout: (state) => initialState,
  },
});

export const systemSettingsActions = systemSettingSlice.actions;
export default systemSettingSlice;
